var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16619 16.909C5.87329 17.2019 5.39842 17.2019 5.10553 16.909C4.81263 16.6161 4.81263 16.1412 5.10553 15.8483L7.75718 13.1967L8.81784 14.2573L6.16619 16.909Z",
    fill: "#009BDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8334 16.909L15.1818 14.2573L16.2425 13.1967L18.8941 15.8483C19.187 16.1412 19.187 16.6161 18.8941 16.909C18.6012 17.2019 18.1263 17.2019 17.8334 16.909Z",
    fill: "#009BDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7C2.25 5.48122 3.48122 4.25 5 4.25H19C20.5188 4.25 21.75 5.48122 21.75 7V17C21.75 18.5188 20.5188 19.75 19 19.75H5C3.48122 19.75 2.25 18.5188 2.25 17V7ZM5 5.75C4.94444 5.75 4.88972 5.75363 4.83607 5.76065L11.1161 12.0407C11.6043 12.5288 12.3957 12.5288 12.8839 12.0407L19.1639 5.76065C19.1103 5.75362 19.0556 5.75 19 5.75H5ZM3.75 7C3.75 6.93548 3.75489 6.8721 3.76431 6.81021L10.0554 13.1013C11.1294 14.1753 12.8706 14.1753 13.9445 13.1013L20.2357 6.81019C20.2451 6.87208 20.25 6.93547 20.25 7V17C20.25 17.6904 19.6904 18.25 19 18.25H5C4.30964 18.25 3.75 17.6904 3.75 17V7Z",
    fill: "#009BDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.fe56da3480c5ba1d3542cb9c63e639ca.svg";
export { ForwardRef as ReactComponent };